import styled from 'styled-components';
import { Tag } from 'antd';

export const StyledTag = styled(Tag)`
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 14px;
  border: none;
`;




